import { AssetType } from '@nemuru-eng/js-api-client';
import { z } from 'zod';

import { GetTextIdTranslationType } from '@/components/shared/hooks/useTranslation';
import { requiredEnum, requiredString } from '@/utils/zodUtils';

export const UtilitiesSupplyDetailsFormSchema = (t: GetTextIdTranslationType) =>
  z
    .object({
      type: requiredEnum(AssetType),
      description: z.string().nullable(),
      cups: requiredString(t),
    })
    .strict();

export type UtilitiesSupplyDetailsFormType = z.infer<ReturnType<typeof UtilitiesSupplyDetailsFormSchema>>;
